import { render, staticRenderFns } from "./ReadonlyMobileBox.vue?vue&type=template&id=72ad4b26&scoped=true"
import script from "./ReadonlyMobileBox.vue?vue&type=script&lang=ts"
export * from "./ReadonlyMobileBox.vue?vue&type=script&lang=ts"
import style0 from "./ReadonlyMobileBox.vue?vue&type=style&index=0&id=72ad4b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ad4b26",
  null
  
)

export default component.exports